import { AnimatePresence, Transition, motion } from 'framer-motion';
import { ReactNode } from 'react';

type HeightToggleProps = {
    children: ReactNode;
    show: boolean;
    transition?: Transition;
    fullWidth?: boolean;
};

const HeightToggle = ({
    children,
    show,
    transition = { duration: 0.2 },
    fullWidth = false,
}: HeightToggleProps) => {
    return (
        <AnimatePresence initial={false}>
            {show && (
                <motion.div
                    key="content"
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { opacity: 1, height: 'auto' },
                        collapsed: { opacity: 0, height: 0 },
                    }}
                    transition={transition}
                    style={{ width: fullWidth ? '100%' : undefined }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default HeightToggle;
